import mixpanel from 'mixpanel-browser';

const initOptions = { ignore_dnt: true };
const isProduction = (process.env.VITE_NODE_ENV === "production" && process.env.VITE_SERVER_ENV === "production");

if (!isProduction) {
  initOptions['debug'] = true;
}

mixpanel.init(process.env.VITE_MIXPANEL_PROJECT_TOKEN, initOptions);

export default mixpanel;